<template>
  <div class="carousel-vue carousel-vue-feature">
    <VueSlickCarousel ref="carousel" v-bind="settings" @afterChange="onAfterChange">
      <CheckboxCard v-for="(feature, index) in this.featuresByPassionSelected" :key="index" :name="feature.name"
        :imageBackground="feature.image" :title="feature.description" :description="feature.subDescription"
        @selectFeature="onSelectFeature" :featureSelected="featureSelected" :isPassion="false"
        :idAnalytics="feature.analytics" :priceScale="feature.priceScale" />
    </VueSlickCarousel>
  </div>
</template>
   
<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import CheckboxCard from './../CheckboxCard.vue'

export default {
  name: 'CarouselFeature',
  components: { VueSlickCarousel, CheckboxCard },
  props: ["featuresByPassionSelected", "featureSelected"],
  watch: {
    step() {
      document.querySelector('.cards-area').scrollTo(0, 0);
    }
  },
  methods: {
    onSelectFeature(selectFeature) {
      this.$emit('clickSelectFeatureCarousel', selectFeature);
    },

    onAfterChange() {
      if (this.$refs.carousel) {
        const slides = this.$refs.carousel.$children || []
        slides.forEach(slide => {
          slide.clickable = true;
        })
      }
    },
  },
  data() {
    return {
      settings: {
        "arrows": false,
        "dots": true,
        "speed": 500,
        "slidesToShow": 3,
        "centerMode": true,
        "infinite": false,
        "centerPadding": "5px",
        "pauseOnHover": true,
        "focusOnSelect": true,
        "responsive": [
          {
            "breakpoint": 353,
            "settings": {
              "slidesToShow": 1,
              "centerPadding": "25px",
            }
          },
          {
            "breakpoint": 372,
            "settings": {
              "slidesToShow": 1,
              "centerPadding": "40px",
            }
          },
          {
            "breakpoint": 412,
            "settings": {
              "slidesToShow": 1,
              "centerPadding": "50px",
            }
          },
          {
            "breakpoint": 471,
            "settings": {
              "slidesToShow": 1,
              "centerPadding": "70px",
            }
          },
          {
            "breakpoint": 520,
            "settings": {
              "slidesToShow": 1,
              "centerPadding": "100px",
            }
          },
          {
            "breakpoint": 640,
            "settings": {
              "slidesToShow": 3,
              "centerPadding": "25px",
            }
          }
        ]

      }
    }
  }
}
</script> 

<style>
.carousel-vue {
  max-width: 767px;
  z-index: 2;
}

.carousel-vue-feature div.slick-slider.slick-initialized {
  position: initial;
  min-height: 328px;
}

.slick-dots {
  position: absolute;
  max-width: 204px;
  height: 28px;
  margin: 0 auto;
  padding: 8px 16px;
  background-color: #fff;
  border-radius: 30px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex !important;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  bottom: 0;
  transform: translateX(-50%);
  left: 50%;
}

.slick-dots li {
  position: initial;
}

.slick-dots li button:before {
  content: "";
  display: block;
  width: 12px;
  height: 12px;
  border-radius: 100%;
  color: transparent;
  background: #D7D2CB;
  position: initial;
}

.slick-dots li.slick-active button:before {
  color: transparent;
  background: #000;
}

.choose-passion .cards-area {
  position: relative;
}
</style>